export const getLastClipboardData =
  // https://microsoft.github.io/roosterjs/docs/classes/roosterjs_editor_core.editor.html#getcustomdata
  // Will call the second paramater to store the value to that key if undefiend
  // Use object so we could set and get value from it
  editor => editor.getCustomData('LAST_CLIPBOARD_DATA', () => ({
    data: null,
  }));
